import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { useStore } from "../../../app/stores/store";
import { Formik, Form } from "formik";
import { observer } from "mobx-react-lite";
import inscriptionsStore from "../../../app/stores/InscriptionsStore";

interface Props {
  id: number;
  appUserId: string;
  catEdicionesId: number;
  codigoInstitucional: string;
  updateCourseList: () => void;
}

export default observer(function ModalEliminarInscripcion(props: Props) {
  const { modalStore, InscriptionsStore } = useStore();

  function handleFormSubmit() {
    let Inscription
    if(props.codigoInstitucional === null){
      Inscription = {
        id: props.id,
        appUserId: props.appUserId,
        codigoCursoId: props.catEdicionesId,
        solicitud: "",
        codigoInstitucional: "",
      };
    }else{
      Inscription = {
        id: props.id,
        appUserId: props.appUserId,
        codigoCursoId: props.catEdicionesId,
        solicitud: "",
        codigoInstitucional: props.codigoInstitucional,
      };
    }

    InscriptionsStore.deleteInscription(Inscription).then(() => {
      modalStore.closeModal();

      props.updateCourseList();
    });
  }

  return (
    <div className="modal_pago_cur modal-reset-password">
      <div className="modal_pago_head">
        <h1>Desmatricular</h1>
      </div>

      <Formik
        enableReinitialize
        onSubmit={(values) => {
          handleFormSubmit();
        }}
        initialValues={{}}
      >
        {({ handleSubmit, isValid, isSubmitting, dirty }) => (
          <Form
            onSubmit={handleSubmit}
            autoComplete="off"
            className="contenido_modal_pago"
          >
            <p>¿Seguro que deseas eliminar los registros de este usuario en el curso?</p>

            <div className="botones_pago_modal">
                <Button
                loading={InscriptionsStore.loading}
                content={"Cancelar"}
                className="gray"
                onClick={modalStore.closeModal}
              />
              <Button
                loading={InscriptionsStore.loading}
                type="submit"
                content={"Confirmar"}
                className="blue"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
});
